import { useEffect, useState } from 'react';
import { X, MoveHorizontal } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function DragTutorial({ onClose }) {
  const [step, setStep] = useState(0);

  useEffect(() => {
    // Auto-advance animation
    const interval = setInterval(() => {
      setStep((prev) => (prev + 1) % 3);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm animate-in fade-in">
      <div className="relative max-w-2xl mx-4">
        {/* Close button */}
        <Button
          onClick={onClose}
          className="absolute -top-4 -right-4 rounded-full w-10 h-10 p-0 bg-[#FF5A00] hover:bg-[#FF7A33] z-10"
          data-testid="close-tutorial"
        >
          <X className="h-5 w-5" />
        </Button>

        {/* Tutorial content */}
        <div className="glass-card p-8 rounded-2xl border-2 border-[#FF5A00]">
          <h2 className="text-3xl font-bold text-white mb-4 text-center" style={{ fontFamily: 'Outfit' }}>
            Arraste e Solte para Trocar Posições! 🎯
          </h2>
          
          <p className="text-[#A1A1AA] text-center mb-8 text-lg">
            Você pode reorganizar seu time facilmente arrastando as cartas
          </p>

          {/* Animation area */}
          <div className="relative h-64 bg-black/30 rounded-xl mb-6 overflow-hidden">
            {/* Background grid */}
            <div className="absolute inset-0 opacity-20">
              <div className="grid grid-cols-2 gap-8 p-8 h-full">
                <div className="border-2 border-dashed border-white/30 rounded-lg" />
                <div className="border-2 border-dashed border-white/30 rounded-lg" />
              </div>
            </div>

            {/* Animated cards */}
            <div className="absolute inset-0 p-8 flex items-center justify-center gap-8">
              {/* Card 1 - Static */}
              <div
                className="w-24 h-32 rounded-lg border-2 border-[#FF5A00] flex flex-col items-center justify-center p-2 transition-all duration-500"
                style={{
                  background: 'linear-gradient(180deg, rgba(255, 90, 0, 0.15) 0%, rgba(20, 21, 28, 0.95) 100%)',
                  backdropFilter: 'blur(12px)',
                  opacity: step === 1 ? 0.3 : 1
                }}
              >
                <div className="w-12 h-12 rounded-full bg-[#FF5A00] mb-2" />
                <p className="text-white font-bold text-xs stats-font">ST</p>
              </div>

              {/* Card 2 - Moving */}
              <div
                className="w-24 h-32 rounded-lg border-2 border-[#00FF66] flex flex-col items-center justify-center p-2 transition-all duration-1000 ease-in-out"
                style={{
                  background: 'linear-gradient(180deg, rgba(0, 255, 102, 0.15) 0%, rgba(20, 21, 28, 0.95) 100%)',
                  backdropFilter: 'blur(12px)',
                  transform: step === 1 ? 'translateX(-140px)' : 'translateX(0)',
                  boxShadow: step === 1 ? '0 8px 32px rgba(0, 255, 102, 0.6)' : 'none',
                  zIndex: step === 1 ? 10 : 1
                }}
              >
                <div className="w-12 h-12 rounded-full bg-[#00FF66] mb-2" />
                <p className="text-white font-bold text-xs stats-font">LW</p>
              </div>
            </div>

            {/* Animated arrow */}
            {step === 0 && (
              <div className="absolute top-1/2 left-1/2 transform -translate-y-1/2 animate-pulse">
                <MoveHorizontal className="h-16 w-16 text-[#FF5A00]" style={{ filter: 'drop-shadow(0 0 20px rgba(255, 90, 0, 0.8))' }} />
              </div>
            )}

            {/* Drag hint */}
            {step === 0 && (
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
                <div className="bg-[#FF5A00] text-white px-4 py-2 rounded-full text-sm font-bold animate-bounce">
                  Clique e arraste →
                </div>
              </div>
            )}

            {/* Swap indicator */}
            {step === 2 && (
              <div className="absolute top-4 left-1/2 transform -translate-x-1/2">
                <div className="bg-[#00FF66] text-black px-4 py-2 rounded-full text-sm font-bold animate-in zoom-in">
                  ✓ Posições trocadas!
                </div>
              </div>
            )}
          </div>

          {/* Instructions */}
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-[#FF5A00] flex items-center justify-center flex-shrink-0 font-bold">
                1
              </div>
              <p className="text-white">
                <strong>Clique e segure</strong> em qualquer carta com jogador
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-[#FF5A00] flex items-center justify-center flex-shrink-0 font-bold">
                2
              </div>
              <p className="text-white">
                <strong>Arraste</strong> até outra posição no campo
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-[#FF5A00] flex items-center justify-center flex-shrink-0 font-bold">
                3
              </div>
              <p className="text-white">
                <strong>Solte</strong> para trocar as posições automaticamente
              </p>
            </div>
          </div>

          <Button
            onClick={onClose}
            className="w-full mt-6 btn-primary text-lg py-6"
          >
            Entendi! Vamos lá 🚀
          </Button>
        </div>
      </div>
    </div>
  );
}
